"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluentTheme = void 0;
var createTheme_1 = require("./createTheme");
exports.FluentTheme = (0, createTheme_1.createTheme)({});
//# sourceMappingURL=FluentTheme.js.map